import React, { Component } from "react";
import gql from "graphql-tag";
import { Mutation } from "react-apollo";

import { CommandBarButton } from "office-ui-fabric-react/lib/Button";

class ShipmentToArchive extends Component {
  render() {
    const { items } = this.props;

    return (
      <Mutation mutation={UPDATE_SHIPMENT_ARCHIVED_FLAG}>
        {(mutate, { data }) => (
          <CommandBarButton
            styles={{ root: { padding: "10px" } }}
            disabled={items.length > 0 ? false : true}
            iconProps={{ iconName: "Archive" }}
            title="Send selected shipments to archive"
            onClick={e => {
              items.map((item, key) => {
                mutate({
                  refetchQueries: [
                    {
                      query: GET_SHIPMENTS,
                      variables: { archived: false }
                    }
                  ],
                  variables: {
                    id: item.id,
                    archived: true
                  }
                })
                  .then(res => {
                    console.log(res);
                  })
                  .catch(err => {
                    console.log(err);
                  });
              });
            }}
          />
        )}
      </Mutation>
    );
  }
}

const UPDATE_SHIPMENT_ARCHIVED_FLAG = gql`
  mutation($id: Int!, $archived: Boolean) {
    updateShipmentById(
      input: { id: $id, shipmentPatch: { archived: $archived } }
    ) {
      shipment {
        id
        archived
      }
    }
  }
`;

const GET_SHIPMENTS = gql`
  query allShipments($archived: Boolean) {
    allShipments(condition: { archived: $archived }) {
      nodes {
        id
        archived
      }
    }
  }
`;

export default ShipmentToArchive;



// WEBPACK FOOTER //
// ./src/common/Buttons/_ShipmentToArchive.js